import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  show() {
    const file = this.inputTarget.files[0]
    if (!file) {
      this.previewTarget.innerHTML = ""
      this.previewTarget.classList.add("hidden")
      return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.innerHTML = `<img src="${e.target.result}" class="w-20 h-20 object-cover rounded-lg border border-gray-200" />`
      this.previewTarget.classList.remove("hidden")
    }
    reader.readAsDataURL(file)
  }
}
